import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import tinycolor2 from 'tinycolor2';
import { useEvent } from '../../../../data/hooks/eventHooks';
import { useFilteredParticipants } from '../../../../data/hooks/participant/useFilteredParticipants';
import { useSessionsInProgress } from '../../../../data/hooks/schedule/useSessionsInProgress';
import { useSidepanelWallpaper } from '../../../../data/hooks/ui/useSidepanelWallpaper';
import styles from './Wallpaper.module.scss';

const TRANSITION_TIME = 1000;

const Wallpaper = (props) => {
    const { eventId } = useParams(),
        event = useEvent(eventId),
        wallpaper = useSidepanelWallpaper(),
        [currentWallpaper, setCurrentWallpaper] = useState(wallpaper),
        activeSession = useSessionsInProgress(event.id),
        { primary_color } = event?.settings || { primary_color: 'white' },
        tinyPrimaryColor = primary_color
            ? tinycolor2(primary_color).toHsl().h
            : '',
        backgroundColor = tinycolor2({
            h: tinyPrimaryColor,
            s: '53%',
            l: '95%',
        }).toString('hsl'),
        [visible, setVisible] = useState(false),
        [, filterParams] = useFilteredParticipants(event.id);

    useEffect(() => {
        setVisible(false);
        if (wallpaper) {
            let start = new Date(),
                loading = true,
                image = new Image();
            image.onload = () => {
                let diff = TRANSITION_TIME - (new Date() - start);
                if (diff < 0) diff = 0;
                setTimeout(() => {
                    if (loading) {
                        setCurrentWallpaper(wallpaper);
                        setVisible(true);
                    }
                }, diff);
            };
            image.src = wallpaper;
            return () => (loading = false);
        } else {
            let timeout = setTimeout(() => {
                setCurrentWallpaper(null);
                setVisible(true);
            }, TRANSITION_TIME);
            return () => clearTimeout(timeout);
        }
    }, [wallpaper]);

    return (
        <>
            <div className={styles.background} style={{ backgroundColor }} />
            <div
                className={[
                    styles.wallpaper,
                    currentWallpaper ? '' : styles.animated,
                    filterParams?.connections
                        ? styles.faded
                        : visible
                        ? styles.visible
                        : styles.hidden,
                ].join(' ')}
                style={{
                    backgroundColor,
                    backgroundImage: currentWallpaper
                        ? `url("${currentWallpaper}")`
                        : null,
                }}
            >
                {currentWallpaper ? null : (
                    <img src={'img/network-connections2.png'} />
                )}
            </div>
        </>
    );
};

export default Wallpaper;
